import TcFormWrapper from 'components/UI/FormWrapper/TcFormWrapper';
import TcFormItem from 'components/UI/form/TcFormItem';
import TcInput from 'components/UI/form/input/TcInput';
import TcSelectReduxSearch from 'components/UI/form/input/TcSelectReduxSearch';
import TcTextarea from 'components/UI/form/input/TcTextarea';
import TcAddressAutocomplete from 'components/UI/form/input/TcAddressAutocomplete';
import { numberRegex } from 'global/Constants/globalConstants';
import { IActors } from 'global/Models/globalModels';
import { IMapIrSearchResult } from 'global/helperFunctions/mapIrFunctions';
import { getAllCitiesWithoutSearch } from 'redux/reducer/basicData/allCitiesWithoutSearch';
import { getAllProvinceWithoutSearch } from 'redux/reducer/basicData/allProvinceWithoutSearch';

export interface address extends IActors {
  fullAddress: string;
  postalCode: string;
  latitude: number;
  longitude: number;
  exclusiveCode: string;
  id: number;
  cityId: number;
  cityTitle: string;
  provinceId: number;
  provinceTitle: string;
  jetCityId: string;
  cityETipaxId: number;
  description: null;
  floor: number;
  plaque: number;
  unit: number;
  start: string;
  end: string;
}

export interface ltlSourceCity {
  id: number;
  title: string;
  jetId: string;
  eTipaxId: number;
}

export interface palletValidation {
  title: string;
  width: number;
  length: number;
  height: number;
  minWidth: number;
  minLength: number;
  minHeight: number;
  maxWidth: number;
  maxLength: number;
  maxHeight: number;
  maxWeight: number;
  minWeight: number;
  order: number;
  editable: true;
  maxGlueAmount: number;
  maxBubbleWrapAmount: number;
  maxSalary: number;
  id: number;
  isActive: true;
  creatorId: number;
  modifierId: number;
  creationDate: string;
  modificationDate: string;
  creator: string;
  modifier: string;
  minPrice: number;
  maxPrice: number;
  packagingGroupId: number;
  packagingGroupTitle: string;
  jetIdPackingType: string;
  creationTime: string;
  modificationTime: string;
}

export interface peopleAddress extends IActors {
  title: string;
  isDefault: boolean;
  address: address;
  id: number;
  addressesId: number;
  peopleId: number;
  peopleAddressTypeId: number;
  cityETipaxId: number;
}

export interface peopleAddressCustomerLinkLocationsFromJet extends IActors {
  id: number;
  mobileNumber: string;
  title: string;
  cityId: string;
  igtCityId: string;
  cityName: string;
  lat: string;
  long: string;
  address: string;
}
export interface ltlPalletWorkingDate {
  id: number;
  date: string;
  start: string;
  end: string;
  type: string;
  typeTitle: string;
}

export interface lockerAddress {
  orderNumber: string;
  lockerAmount: number;
  taxAmount: number;
  finalAmount: number;
  cycleState: string;
  cancleDescription: string;
  locker: {
    id: number;
    serial: number;
    isActive: string;
    kiosk: {
      id: number;
      isActive: string;
      isRental: string;
      description: string;
      address: string;
      addressEn: string;
      lat: string;
      lon: string;
      kioskType: {
        id: string;
        description: string;
        lockerTypes: [
          {
            id: number;
            description: string;
            length: number;
            width: number;
            height: number;
            weight: number;
          }
        ];
      };
      lockers: string[];
      shifts: [
        {
          id: string;
          startTime: string;
          endTime: string;
        }
      ];
    };
    lockerType: {
      id: number;
      description: string;
      length: number;
      width: number;
      height: number;
      weight: number;
    };
    orders: [string];
  };
  id: number;
  orderComment: string;
  registerDate: string;
  registerTime: string;
  expireDate: string;
  startDate: string;
  startTime: string;
  endDate: string;
  endTime: string;
  paymentType: string;
  cancleReason: string;
  histories: [
    {
      id: number;
      orderState: string;
      date: string;
      time: string;
      username: string;
    }
  ];
  passwords: [
    {
      id: number;
      paid: string;
      needPayment: string;
      amount: number;
      content: string;
      type: string;
      expireDate: string;
      expireTime: string;
      order: string;
    }
  ];
}

const title = 'آدرس';
const englishTitle = 'address';
const filterItems = (
  <>
    <TcFormItem label='عنوان' name='title'>
      <TcInput placeholder='عنوان' />
    </TcFormItem>

    <TcFormItem label='شهر' name='cityId'>
      <TcSelectReduxSearch reducerName='city' reducerListProperty='allCitiesWithoutSearch' getlist={getAllCitiesWithoutSearch} />
    </TcFormItem>

    <TcFormItem label='استان' name='provinceId'>
      <TcSelectReduxSearch reducerName='province' reducerListProperty='allProvincesWithoutSearch' getlist={getAllProvinceWithoutSearch} />
    </TcFormItem>
  </>
);
const inputs = (onAddressSelect?: (_location: IMapIrSearchResult) => void) => (
  <>
    <TcFormWrapper>
      <TcFormItem label='عنوان آدرس' name='title' rules={[{ required: true, message: 'عنوان را وارد کنید' }]}>
        <TcInput placeholder='عنوان آدرس' />
      </TcFormItem>

      <TcFormItem
        label='کدپستی'
        name='postalCode'
        rules={[
          {
            max: 10,
            min: 10,
            message: 'کدپستی یک عدد 10 رقمی می‌باشد',
          },
          {
            whitespace: true,
            message: 'کدپستی نمی‌تواد شامل فاصله باشد',
          },
          {
            pattern: numberRegex,
            message: 'کدپستی شامل اعداد می‌باشد',
          },
        ]}>
        <TcInput placeholder='کدپستی' />
      </TcFormItem>
      <TcFormItem label='پلاک' name='plaque' rules={[{ required: true, message: 'پلاک را وارد کنید' }]}>
        <TcInput placeholder='پلاک' maxLength={5} />
      </TcFormItem>

      <TcFormItem label='واحد' name='unit'>
        <TcInput placeholder='واحد' />
      </TcFormItem>

      <TcFormItem label='طبقه' name='floor'>
        <TcInput placeholder='طبقه' />
      </TcFormItem>

      <TcFormItem label='شهر' name='cityId' rules={[{ required: true, message: 'شهر را وارد کنید' }]}>
        <TcSelectReduxSearch reducerName='city' reducerListProperty='allCitiesWithoutSearch' getlist={getAllCitiesWithoutSearch} prefixLabelPropertyName='provinceTitle' />
      </TcFormItem>

      <TcFormItem label='نشانی پستی' name='fullAddress' rules={[{ required: true, message: 'نشانی را وارد کنید' }]}>
        {onAddressSelect ? (
          <TcAddressAutocomplete placeholder='نشانی پستی (مثلاً کوچه بهار، خیابان انقلاب را جستجو کنید)' onSelectLocation={onAddressSelect} />
        ) : (
          <TcTextarea placeholder='نشانی پستی' />
        )}
      </TcFormItem>
      <TcFormItem label='توضیحات' name='description'>
        <TcTextarea placeholder='توضیحات' />
      </TcFormItem>
      {/* {isSender && (
        <TcFormItem label='آدرس پیشفرض' name='isDefault' valuePropName='checked'>
          <TcCheckbox />
        </TcFormItem>
      )} */}
      {/* <TcFormItem label='استان' name='provinceId' rules={[{ required: true, message: 'استان را وارد کنید' }]}>
        <TcSelectReduxSearch reducerName='provinceStore' reducerListProperty='allProvincesWithoutSearch' getlist={getAllProvinceWithoutSearch} />
      </TcFormItem> */}
      {/* <TcFormItem
        label='طول جغرافیایی '
        name='longitude'
        rules={[
          {
            pattern: /^[-+]?[0-9۰-۹]*(\.[0-9۰-۹]+)$/,
            message: 'طول جغرافیایی یک اعدد اعشاری می‌باشد',
          },
        ]}>
        <TcInput placeholder='طول جغرافیایی' />
      </TcFormItem>
      <TcFormItem
        label='عرض جغرافیایی '
        className=''
        name='latitude'
        rules={[
          {
            pattern: /^[-+]?[0-9۰-۹]*(\.[0-9۰-۹]+)$/,
            message: 'عرض جغرافیایی یک اعدد اعشاری می‌باشد',
          },
        ]}>
        <TcInput placeholder='عرض جغرافیایی' />
      </TcFormItem> */}
    </TcFormWrapper>
  </>
);

const columns = () => [
  {
    title: 'شهر',
    key: 'cityTitle',
    dataIndex: 'cityTitle',
    render: (_text: any, record: Record<string, any>) => {
      return record.address?.provinceTitle + ' / ' + record.address?.cityTitle;
    },
  },
  {
    title: 'آدرس',
    key: 'fullAddress',
    dataIndex: 'fullAddress',
    render: (_text: any, record: Record<string, any>) => {
      return record.address?.fullAddress;
      // + `, پلاک ${record.address?.plaque} , واحد ${record.address?.unit} , طبقه ${record.address?.floor}`;
    },
  },
  // {
  //   title: 'طول جغرافیایی',
  //   key: 'longitude',
  //   dataIndex: 'longitude',
  //   render: (_text: any, record: Record<string, any>) => {
  //     return record.address?.longitude?.toFixed(2);
  //   },
  // },
  // {
  //   title: 'عرض جغرافیایی',
  //   key: 'latitude',
  //   dataIndex: 'latitude',
  //   render: (_text: any, record: Record<string, any>) => {
  //     return record.address?.latitude?.toFixed(2);
  //   },
  // },
];

const addressModel = { columns, title, englishTitle, filterItems, inputs };

export default addressModel;
